import SharedEnergyWidget from './SharedEnergyWidget';

export default SharedEnergyWidget;
